module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/main-visual-text-3653a536f94aefc2a560411193c886b8.svg";